import React from "react";
import { reviews } from "../data/reviews";
import ReviewCard from "../components/ReviewCard";

function Reviews() {
  return (
    <div style={{ padding: "50px 20px" }}>
      <h1>🧪 Tests & Reviews</h1>

      <div
        style={{
          display: "grid",
          gridTemplateColumns: "repeat(auto-fill, minmax(300px, 1fr))",
          gap: "25px",
          marginTop: "30px"
        }}
      >
        {reviews.map(review => (
          <ReviewCard key={review.id} review={review} />
        ))}
      </div>
    </div>
  );
}

export default Reviews;